import Home    from "@/i18n/views/Home";
import NavBar  from "@/i18n/components/NavBar";
import Login   from "@/i18n/views/Login";
import Demands from "@/i18n/views/Demands";
import Common  from "@/i18n/common/index";
import Profile from "@/i18n/views/Profile";
import Users   from "@/i18n/views/Users";
import Chat    from "@/i18n/views/Chat";

export default {
    en: {
        common   : {
            ...Common.en
        },
        component: {
            navbar: {
                ...NavBar.en
            }
        },
        view     : {
            home   : {
                ...Home.en
            },
            login  : {
                ...Login.en
            },
            demands: {
                ...Demands.en
            },
            profile: {
                ...Profile.en
            },
            users  : {
                ...Users.en
            },
            chats  : {
                ...Chat.en
            }
        }
    },
    el: {
        common   : {
            ...Common.el
        },
        component: {
            navbar: {
                ...NavBar.el
            }
        },
        view     : {
            home   : {
                ...Home.el
            },
            login  : {
                ...Login.el
            },
            demands: {
                ...Demands.el
            },
            profile: {
                ...Profile.el
            },
            users  : {
                ...Users.el
            },
            chats  : {
                ...Chat.el
            }
        }
    }
};
